<template>
  <vx-card>
    <div>
      <div class="flex justify-between items-center">
        <p style="font-size: 18px; font-weight: 700">교량</p>
        <div class="flex justify-end">
          <vs-button class="ml-4" color="secondary" type="border" @click.stop.prevent="onClickDownloadExcel">엑셀(FMS) 내려받기</vs-button>
          <vs-button v-if="isEditable && !!fieldId" class="ml-4" color="secondary" type="border" @click="onClickDelete">삭제</vs-button>
          <vs-button class="ml-4" color="secondary" type="border" @click="onClickMoveList">목록</vs-button>
          <vs-button v-if="isEditable" class="ml-4" color="secondary" @click="onClickSave">저장</vs-button>
        </div>
      </div>

      <!-- 기본정보 -->
      <div class="mt-28px">
        <h5 class="mb-4"><i class="dot"></i> 기본정보</h5>
        <div class="writeGridContainer">
          <div>
            <div>관리주체</div>
            <ml-input readonly v-model="form.management_entity" />
          </div>
          <div>
            <div>소유자</div>
            <ml-input readonly v-model="form.owner" />
          </div>
          <div>
            <div>전화번호</div>
            <ml-input v-model="form.phoneNumber" :readonly="readonly" />
          </div>
          <div>
            <div>보관자</div>
            <ml-input v-model="form.custodian" :readonly="readonly" />
          </div>
          <div>
            <div>관리방법</div>
            <vs-select autocomplete v-model="form.관리방법">
              <vs-select-item text="직접관리" value="직접관리" />
              <vs-select-item text="위탁관리" value="위탁관리" />
            </vs-select>
          </div>
          <div>
            <div>소관부서</div>
            <ml-input v-model="form.소관부서" :readonly="readonly" />
          </div>
          <div>
            <div>담당주무관</div>
            <ml-input v-model="form.담당주무관" :readonly="readonly" />
          </div>
        </div>
      </div>
    </div>

    <!-- 시설물 정보 -->
    <bridge-write-body :form="form" :category-info="categoryInfo" :readonly="readonly" />

    <!-- 관리 부서 및 업체 등록 -->
    <company-add-module
      title="관리 부서 및 업체 등록"
      :tableColumns="[
        { head: '구분', key: 'com_type' },
        { head: '부서(업체)명', key: 'com_name' },
        { head: '연락처', key: 'phone' },
      ]"
      :isSimple="true"
      :readonly="readonly"
      v-model="companyList"
      @remove="removeCompany"
    />

    <!-- 전경사진 -->
    <photo-upload-grid-module :row-count="2" :grid-count="2" v-model="form.photoList" section-title="전경사진" placeholder="전경사진" :readonly="readonly" />

    <file-upload-module v-model="fileList" class="mt-28px" :readonly="readonly" target="field" />
  </vx-card>
</template>

<script>
import FileUploadModule from "@/views/modules/FileUploadModule";
import CompanyAddModule from "@/views/_BS/components/CompanyAddModule";
import DateSelector from "@/components/selector/DateSelector";
import DateSelectorRang from "@/components/selector/DateSelectorRang";
import SignField from "@/components/SignField.vue";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule";
import BridgeWriteBody from "@/views/fields/single-page/bridge/BridgeWriteBody.vue";
import ComplexWriteBody from "@/views/fields/template/ComplexWriteBody.vue";
import ExcelJS from "exceljs";

export default {
  components: {
    ComplexWriteBody,
    BridgeWriteBody,
    FileUploadModule,
    CompanyAddModule,
    DateSelector,
    DateSelectorRang,
    SignField,
    PhotoUploadGridModule,
  },
  data() {
    return {
      form: {
        phoneNumber: "",
        custodian: "",
        관리방법: "직접관리",
        소관부서: "",
        담당주무관: "",

        facilityNumber: "",
        managementNumber: "",
        facilityName: "",
        routeDivision: "",
        routeDetail: "",

        facility_category_id: 0,

        cat1: "",
        cat2: "",
        cat3: "",
        classification: "",

        socEvaluationTarget: "",
        address: "",
        management_entity: "",
        management_type: "",
        owner: "",
        ownerType: "",
        businessPlanApprovalDate: "",
        completionDate: "",
        defectLiabilityExpirationDate1: "",
        detailedSpecifications: "",
        safetyInspectionAndDiagnosisHistory: "",
        repairAndReinforcementHistory: "",
        accessibleVentCover: "",
        designPeriod: "",
        designer: "",
        defectLiabilityExpirationDate2: "",
        constructionPeriod: "",
        contractor: "",
        totalConstructionCost: "",
        seismicDesignTarget: "",
        seismicDesignApplication: "",
        seismicDesignStandard: "",
        seismicPerformanceEvaluation: "",
        seismicReinforcement: "",
        young21Target: "",
        auditPeriod: "",
        auditor: "",
        projectOwner: "",
        constructionName: "",
        defectLiabilityExpirationDate3: "",
        constructionSupervisor: "",
        creationDate: "",
        author: "",
        signature: "",
        lastModifiedDate: "",
        lastModifiedBy: "",
        remarks: "",

        bridgeStartLocation: "",
        bridgeEndLocation: "",
        designLiveLoad: "",
        permittedLiveLoad: "",

        bridgeLength: "",
        bridgeSpanCount: "",
        bridgeMaxSpanCount: "",
        bridgeSidewalkWidth: "",
        bridgeRoadwayWidth: "",
        bridgeTotalWidth: "",
        bridgeUpstreamLanes: "",
        bridgeDownstreamLanes: "",
        bridgeTotalLanes: "",
        seismicDesignApplied: "",

        상부구조: {
          경간구성: "",
          하부통과제한높이: "",
          대표: {
            경간형식: "",
            받침종류: "",
            신축이음종류: "",
          },
          기타: {
            경간형식: "",
            받침종류: "",
            신축이음종류: "",
          },
        },
        하부구조: {
          교차노선: "",
          교차하천: "",
          대표: {
            교각형식: "",
            교각기초형식: "",
            교대형식: "",
            교대기초형식: "",
          },
          기타: {
            교각형식: "",
            교각기초형식: "",
            교대형식: "",
            교대기초형식: "",
          },
        },

        bridgeStatus: "",
        attachmentContent: "",
        otherSpecifications: "",

        companyList: [],
        photoList: [],
      },

      companyList: [],
      userList: [],
      joinUsers: [],
      fileList: [],
      categoryInfo: {
        facility_category_id: 0,
        cat1: "",
        cat2: "",
        cat3: "",
        classification: "",
      },
    };
  },
  computed: {
    projectId() {
      return Number(this.$route.params.proj_id);
    },
    fieldId() {
      return this.$route.params.fieldId;
    },
    isAdmin() {
      let isAdmin = false;
      const myInfo = this.$store.state.auth.userInfo;
      isAdmin = isAdmin || parseInt(myInfo.is_superuser) > 0;
      return isAdmin;
    },
    /**
     * 현재 사용자가 프로젝트 관리자인지 확인합니다.
     * 프로젝트 관리자는 사업장을 등록/수정/삭제할 수 있습니다.
     * @returns {boolean}
     */
    isProjectManager() {
      const memberInfo = this.$store.state.member.memberInfo;
      if (memberInfo) {
        if (memberInfo.is_superuser) {
          return true;
        }

        const projects = memberInfo.projects;
        if (projects && projects.length > 0) {
          for (const project of projects) {
            if (`${project.id}` === `${this.projectId}`) {
              return project.pivot.is_manager;
            }
          }
        }
      }
      return false;
    },
    /**
     * 사업장을 프로젝트 관리자만 수정할 수 있는지 확인합니다.
     * @returns {boolean}
     */
    isFieldEditByManagerOnly() {
      const projectInfo = this.$store.state.project.projectInfo;

      return !!projectInfo.field_edit_by_manager_only;
    },
    isEditable() {
      if (this.isFieldEditByManagerOnly) {
        return this.isProjectManager;
      }
      return true;
    },
    readonly() {
      return !this.isEditable;
    },
  },
  watch: {
    async companyList() {
      await this.initMembers();
    },
  },
  async created() {
    await this.$store.dispatch("member/LOAD_MEMBER_DETAIL");
    await this.$store.dispatch("project/LOAD_PROJECT", {project_id: this.projectId});
  },
  async mounted() {
    if (this.fieldId) {
      await this.loadField();
    }
  },
  methods: {
    async loadField() {
      const fieldId = this.fieldId;
      await this.$store.dispatch("project/LOAD_FIELD", { fieldId });
      const info = this.$store.state.project.fieldInfo;

      this.joinUsers = info.users;
      this.form = { ...this.form, ...info, ...JSON.parse(info.meta) };

      if (info.facility_category) {
        this.form.facility_category_id = info.facility_category.id;
        this.form.cat1 = info.facility_category.cat1;
        this.form.cat2 = info.facility_category.cat2;
        this.form.cat3 = info.facility_category.cat3;
        this.form.classification = info.facility_category.classification;

        this.categoryInfo = {
          facility_category_id: info.facility_category.id,
          cat1: info.facility_category.cat1,
          cat2: info.facility_category.cat2,
          cat3: info.facility_category.cat3,
          classification: info.facility_category.classification,
        };
      }

      // 첨부파일
      this.form.fileList = info.attachments || [];

      // this.form.photoList 항목이 2개보다 적을 경우, 빈 항목을 추가한다.
      if (this.form.photoList.length < 2) {
        for (let i = this.form.photoList.length; i < 2; i++) {
          this.form.photoList.push({ id: "", url: "" });
        }
      }

      if (this.form.companies && info.companies.length > 0) {
        const companies = [];
        for (const company of info.companies) {
          companies.push(company);
        }
        this.companyList = companies;

        await this.initMembers();
      }

      if (this.form.fileList) {
        this.fileList = this.form.fileList;
      }
    },

    async initMembers() {
      const joinUsers = this.joinUsers;
      const members = [];
      for (const company of this.companyList) {
        members.push(...(await this.loadMember(company.id)));
      }

      for (const member of members) {
        let join_project = false;
        for (const user of joinUsers) {
          if (user.id === member.id) {
            join_project = true;
            break;
          }
        }
        member.join_project = join_project;
      }

      this.userList = members;
    },

    async loadMember(company_id) {
      const page = 1;
      const perPage = 100;
      await this.$store.dispatch("company/LOAD_MEMBER_LIST", { page, perPage, company_id });
      return JSON.parse(JSON.stringify(this.$store.state.company.memberList));
    },

    removeCompany(company) {
      let i = 0;
      for (i = 0; i < this.joinUsers.length; i++) {
        const usr = this.joinUsers[i];
        if (usr.company_id === company.id) {
          this.joinUsers.splice(i, 1);
          i--;
        }
      }
    },

    customAlert(msg, title) {
      const customAlert = new CustomEvent("customAlert", {
        detail: {
          title: title ? title : "오류가 발생했습니다",
          message: msg,
        },
      });
      window.dispatchEvent(customAlert);
    },
    onClickSave() {
      // 필수 : facilityNumber, facilityName,
      if (!this.form.facilityNumber) {
        this.customAlert("시설물 번호를 입력해주세요.");
        return;
      }
      if (!this.form.facilityName) {
        this.customAlert("시설물명을 입력해주세요.");
        return;
      }

      const option = {
        project_id: this.projectId, // 프로젝트 ID
        field_name: this.form.facilityName, // 현장(시설물, 사업장) 이름
        contract_code: this.form.facilityNumber, // 계약번호
        address: this.form.address, // 주소
        phone: this.form.phoneNumber, // 대표번호
        be_completed_at: this.form.completionDate, // 준공일
        deposit_amount: this.form.totalConstructionCost, // 총공사비
        facility_category_id: this.form.facility_category_id, // Category
        uploads: this.fileList.map((file) => file.id), // 파일
      };

      const company_ids = [];
      for (const com of this.companyList) {
        company_ids.push(com.id);
      }
      const user_ids = [];
      if (this.joinUsers.length > 0) {
        for (const user of this.joinUsers) {
          user_ids.push(user.id);
        }
      }
      option.company_ids = company_ids;
      option.user_ids = user_ids;

      // Meta
      option.meta = { ...this.form };

      this.$emit("save", option);
    },
    onClickDelete() {
      this.$emit("delete", this.fieldId);
    },
    onClickMoveList() {
      this.$emit("moveList");
    },
    async onClickDownloadExcel() {
      // 엑셀 파일 가져오기
      // 파일은 public/fms/ 경로에 저장되어 있다.
      const response = await fetch('/fms/시설물관리대장_교량.xlsx');
      const arrayBuffer = await response.arrayBuffer();

      const workbook = new ExcelJS.Workbook();
      await workbook.xlsx.load(arrayBuffer);

      // 첫번째 시트의 이름 가져오기
      const worksheet = workbook.worksheets[0];

      // 시트에 데이터 입력하기
      this.applyDataToSheet(worksheet);

      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

      let fileName = '';
      if (this.form.facilityName) {
        if (this.form.facilityNumber) {
          fileName = `시설물관리대장_${this.form.facilityName}_${this.form.facilityNumber}`;
        } else {
          fileName = `시설물관리대장_${this.form.facilityName}`;
        }
      } else if (this.form.facilityNumber) {
        fileName = `시설물관리대장_${this.form.facilityNumber}`;
      } else {
        fileName = `시설물관리대장`;
      }
      fileName += '.xlsx';

      const url = window.URL.createObjectURL(blob);

      const a = document.createElement('a');
      a.href = url;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
    },
    applyDataToSheet(worksheet) {
      const cellMatchInfo = {
        facilityNumber: ['W4', 'B20'],  // 시설물번호
        managementNumber: ['W5', 'J20'], // 관리번호
        facilityName: ['W6', 'P20', 'B41'], // 시설물명
        management_entity: ['U13', 'S22'], // 관리주체
        owner: ['U14'], // 소유자
        custodian: ['U15'], // 보관자
        routeDivision: ['Z20'], // 노선-구분
        routeDetail: ['AE20'], // 노선-세부노선
        cat1: ['AU20'], // 시설물구분
        cat3: ['AJ20'], // 시설물종류
        classification: ['AP20'],  // 시설물종별
        socEvaluationTarget: ['AZ20'], // SOC성능평가대상
        address: ['B22'], // 주소
        businessPlanApprovalDate: ['B27'], // 사업계획승인일
        completionDate: ['G27'], // 준공일
        defectLiabilityExpirationDate1: ['O27'], // 하자보수보증종료일
        detailedSpecifications: ['T27'], // 상세제원
        safetyInspectionAndDiagnosisHistory: ['Y27'], // 안전점검진단이력
        repairAndReinforcementHistory: ['AF27'], // 보수보강이력
        accessibleVentCover: ['AL27'], // 통풍구방법
        designer: ['R29'], // 설계자
        contractor: ['AK29'], // 시공자
        totalConstructionCost: ['AW29'], // 총공사비
        seismicDesignTarget: ['E31'], // 지진설계대상
        seismicDesignApplication: ['R31'], // 지진설계적용
        seismicDesignStandard: ['AA31'], // 지진설계기준
        seismicPerformanceEvaluation: ['AK31'], // 지진성능평가
        seismicReinforcement: ['AW31'], // 지진보강
        young21Target: ['B33'], // 영21조대상
        auditor: ['R33'], // 감리자
        projectOwner: ['AA33'], // 사업주체
        constructionName: ['AK33'], // 공사명
        constructionSupervisor: ['AW33'], // 공사감독
        creationDate: ['B36'], // 작성일
        lastModifiedDate: ['AB36'], // 최종 수정일
        lastModifiedBy: ['AQ36'], // 최종 수정자
        remarks: ['D37'], // 비고

        // 상세제원
        bridgeStartLocation: ['K41'], // 교량시작위치
        bridgeEndLocation: ['AA41'], // 교량종료위치
        designLiveLoad: ['AR41'], // 설계활하중
        permittedLiveLoad: ['AW41'], // 허용통행하중

        bridgeLength: ['B45'], // 교량길이
        bridgeSpanCount: ['F45'], // 교량간격수
        bridgeMaxSpanCount: ['K45'], // 최대교간격수
        bridgeSidewalkWidth: ['Q45'], // 보도폭
        bridgeRoadwayWidth: ['V45'], // 도로폭
        bridgeTotalWidth: ['AA45'], // 총폭
        bridgeUpstreamLanes: ['AG45'], // 상류차로수
        bridgeDownstreamLanes: ['AL45'], // 하류차로수
        bridgeTotalLanes: ['AR45'], // 총차로수
        seismicDesignApplied: ['AW45'], // 내진설계적용

        // 상부구조
        상부구조_경간구성: ['Q46'], // 경간구성
        상부구조_하부통과제한높이: ['BA48'], // 하
        상부구조_대표_경간형식: ['K48'], // 대
        상부구조_대표_받침종류: ['X48'], // 대
        상부구조_대표_신축이음종류: ['AN48'], // 대
        상부구조_기타_경간형식: ['K49'], // 기
        상부구조_기타_받침종류: ['X49'], // 기
        상부구조_기타_신축이음종류: ['AN49'], // 기

        // 하부구조
        하부구조_교차노선: ['AW52'], // 교차노선
        하부구조_교차하천: ['BA52'], // 교차하천
        하부구조_대표_교각형식: ['K52'], // 대
        하부구조_대표_교각기초형식: ['V52'], // 대
        하부구조_대표_교대형식: ['AH52'], // 대
        하부구조_대표_교대기초형식: ['AO52'], // 대
        하부구조_기타_교각형식: ['K53'], // 기
        하부구조_기타_교각기초형식: ['V53'], // 기
        하부구조_기타_교대형식: ['AH53'], // 기
        하부구조_기타_교대기초형식: ['AO53'], // 기

        bridgeStatus: ['K54'], // 하천해상교량해당여부
        attachmentContent: ['AH54'], // 부착시설내용
        otherSpecifications: ['K55'], // 기타 상세제원
      };


      for (const key in cellMatchInfo) {
        const cell = cellMatchInfo[key];
        for (const c of cell) {
          worksheet.getCell(c).value = this.form[key] ? this.form[key] : '';
        }
      }


      worksheet.getCell('Y25').value = '';
      worksheet.getCell('AC25').value = '';
      worksheet.getCell('AG25').value = '';
      worksheet.getCell('AJ23').value = '';
      if (this.form.management_type === '중앙부처') {
        worksheet.getCell('Y25').value = 'V';
      } else if (this.form.management_type === '지자체') {
        worksheet.getCell('AC25').value = 'V';
      } else if (this.form.management_type === '(국가/지방)공기업') {
        worksheet.getCell('AG25').value = 'V';
      } else if (this.form.management_type === '민간') {
        worksheet.getCell('AJ23').value = 'V';
      }

      worksheet.getCell('AS25').value = '';
      worksheet.getCell('AX25').value = '';
      worksheet.getCell('AY25').value = '';
      worksheet.getCell('BB23').value = '';
      if (this.form.ownerType === '중앙부처') {
        worksheet.getCell('AS25').value = 'V';
      } else if (this.form.ownerType === '지자체') {
        worksheet.getCell('AX25').value = 'V';
      } else if (this.form.ownerType === '(국가/지방)공기업') {
        worksheet.getCell('AY25').value = 'V';
      } else if (this.form.ownerType === '민간') {
        worksheet.getCell('BB23').value = 'V';
      }

      // 전화번호
      worksheet.getCell('AI14').value = `전화번호: ${this.form.phoneNumber}`;

      // 첨부자료 목록
      const fileNames = this.fileList.map((file) => file.originalName).join(', ');
      worksheet.getCell('AT27').value = fileNames;

      // 설계기간
      worksheet.getCell('B29').value = `${this.form.designPeriod.sDate  } ~ ${  this.form.designPeriod.eDate}`;

      // 공시기간
      worksheet.getCell('AA29').value = `${this.form.constructionPeriod.sDate  } ~ ${  this.form.constructionPeriod.eDate}`;

      // 감리기간
      worksheet.getCell('E33').value = `${this.form.auditPeriod.sDate  } ~ ${  this.form.auditPeriod.eDate}`;

      // 작성자
      worksheet.getCell('M36').value = `${this.form.author }  (인)`;

      // 빈칸으로 만들 칸들 (C22, G22, L22, L24, H43)
      const emptyCells = ['C22', 'H22', 'N22', 'N24', 'K42', 'AA42'];
      for (const cell of emptyCells) {
        worksheet.getCell(cell).value = '';
      }
    }
  },
};
</script>

<style scoped lang="scss">
table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;

  th,
  td {
    font-size: 14px;
    font-weight: 500;
    text-align: center;

    border: 1px solid #cdcdcd;
    padding: 5px;
  }

  th {
    background: #f9f9f9;
    padding: 10px 4px;
  }
}
</style>
<style scoped lang="scss">
.table-list {
  .action-button {
    margin-left: auto;
  }
}

.title {
  font-weight: 500;
  font-size: 16px;
  height: 17px;
  line-height: 17px;
  position: relative;
  padding-left: 12px;

  &::before {
    content: "";
    width: 8px;
    height: 8px;
    background: #7e72f2;
    display: block;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: -8px;
    border-radius: 100%;
  }
}

.title-n {
  font-weight: 500;
  font-size: 16px;
  height: 17px;
  line-height: 17px;
}

.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
}

.size-search {
  width: 200px;
}

.input-se {
  width: 100%;

  &::v-deep .start-end-title {
    width: 114px;
    font-weight: 500;
    font-size: 14px;
    justify-content: flex-start;
  }

  &::v-deep .mr-2 {
    flex: 1;
    margin-right: 10px !important;
  }

  &::v-deep .mr-2 + .mr-2 {
    margin-right: 0 !important;

    &::before {
      content: "~";
      margin-right: 10px;
    }
  }

  &::v-deep .inline-block {
    width: 100% !important;
  }
}

.vs-table-primary .is-selected {
  background: rgba(126, 114, 242, 0.6) !important;
  color: white;
}

.search-item {
  width: 100% !important;
  margin: 0 !important;

  &::v-deep > div:first-child {
    width: 114px !important;
    font-weight: 500;
    font-size: 14px;
  }

  &::v-deep > div:last-child {
    flex: 1 !important;

    .con-select {
      width: 100%;
    }
  }
}

.upload-img {
  width: 100%;
  height: 318px !important;
  margin-top: 22px;
}
</style>

<style lang="scss">
.none-card {
  box-shadow: none;
  border-radius: 0;
  display: inline-block;

  .vx-card__body {
    padding: 0 !important;
  }
}

span.up {
  color: #28c76f;
}

span.down {
  color: #ea5455;
}

.vs-table--tbody-table tr:nth-child(2n) {
  background-color: #f9f9f9;
}
</style>
